// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3OltB","onlyMobile":"styles_onlyMobile__3Yx9m","onlyDesktop":"styles_onlyDesktop__2l9w4"};